export const types = {
  SET_ANNOUNCEMENT: 'SET_ANNOUNCEMENT',
};

export const setAnnouncement = (announcement) => ({
  type: types.SET_ANNOUNCEMENT,
  payload: announcement,
});
